import {visit} from 'unist-util-visit';
import {Node} from 'unist-util-visit/lib';
import {Element, ElementContent, Properties} from 'hast';
import {mediaInterface} from '@techsmith/techsmith-smartplayer';
import timeFormatter from './TimeFormatter';
import Constants from '../constants/Constants';

export interface RehypeTimecodeLinksPluginOptions {
   scrollableElementId: string;
}

/**
 * Plugin to automatically add javascript handler to timecode links.
 */
const rehypeTimecodeLinksPlugin = (options: RehypeTimecodeLinksPluginOptions): ((n: Node) => void) => tree =>
   visit(tree, 'element', (node: Element): void => {
      if (node.tagName === 'p' && node.children.length) {
         node.children.forEach((n: ElementContent, index: number) => {
            if (n.type === 'text' && n.value) {
               const timecodes = Constants.timeCodeRegex.exec(n.value);

               if (timecodes) {
                  const timeInSeconds = timeFormatter.getSecondsFromTimeString(timecodes[0]);
                  const p: Properties = {
                     href: '#',
                     onClick: ((e: MouseEvent) => {
                        e.preventDefault();
                        mediaInterface.currentTime = timeInSeconds;
                        const scrollableElement = document.getElementById(options.scrollableElementId);
                        if (scrollableElement) {
                           scrollableElement.scrollTo({top: 0, behavior: 'smooth'});
                        }
                        return false;
                     }) as any // Typescript thinks this isn't a valid type, but it works.
                  };

                  node.children[index] = {
                     type: 'element',
                     tagName: 'a',
                     properties: p,
                     children: [{type: 'text', value: n.value} as ElementContent]
                  };
               }
            }
         });
      }
   });

export default rehypeTimecodeLinksPlugin;
